module.exports = __webpack_public_path__ + "img/Big Eye Road.cd979852.png";